// src/views/Notifications.js
import React from 'react';

const Test = () => {
  
  console.log('this is a test');
  return <div>this is a test</div>;
};

export default Test;